export type Entries<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][]

export function objectEntries<T extends object>(o: T) {
  return Object.entries(o) as Entries<T>
}
